import { render, staticRenderFns } from "./AtendimentosTable.vue?vue&type=template&id=26436806&scoped=true&"
import script from "./AtendimentosTable.vue?vue&type=script&lang=js&"
export * from "./AtendimentosTable.vue?vue&type=script&lang=js&"
import style0 from "./AtendimentosTable.vue?vue&type=style&index=0&id=26436806&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26436806",
  null
  
)

export default component.exports